'use es6';

import AnchorPopoverBodyInsert from 'rich-text-lib/components/anchor/AnchorPopoverBodyInsert';
import TinyMcePopover from './TinyMcePopover';
import { jsx as _jsx } from "react/jsx-runtime";
function AnchorInsertPopover(props) {
  const {
    editor,
    target,
    anchorList,
    onRemove,
    onInsert,
    removeTempAnchors
  } = props;
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    "data-test-id": "anchor-insert-popover",
    editor: editor,
    target: target,
    open: !!target,
    arrowSize: "medium",
    placement: "bottom left",
    autoPlacement: "vert",
    onRemove: onRemove,
    onCloseComplete: removeTempAnchors,
    closeOnOutsideClick: true,
    animateOnToggle: false,
    renderContent: () => /*#__PURE__*/_jsx(AnchorPopoverBodyInsert, {
      anchorList: anchorList,
      tooltipClassName: "mce-anchor-tooltip",
      onInsert: onInsert.bind(null, target),
      onClose: onRemove
    })
  });
}
export default AnchorInsertPopover;